import { useState, useEffect } from 'react';
import {
  getRemainingTimeWithDate,
  type ResolvedStatus,
} from '../utils/helpers';

export const useRealTimeCountdown = (
  expirationDate: any,
  status: ResolvedStatus,
) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    // Update every second
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    // Clear interval on unmount
    return () => clearInterval(timer);
  }, []);

  return getRemainingTimeWithDate(expirationDate, status, currentTime);
};
